import { ClientChannelString, OpportunitiesType, ServiceCategoryBehaviour, TrialType, YesNo,Status } from '@fitness-force/enum';
import { Injectable, inject } from '@angular/core';
import { CommonService } from '../common/common.service';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { ClassAppointmentBehaviour, ClassStatusNumeric, ClientBookingStatusNumeric, ClientCheckedInStatus, ClientCheckinEventType, ClientPaymentTokenStatus, ClientSubscriptionFreezeStatus, EmailTransactionLogStatus, InvoiceStatusEnum, PaymentDerivedStatus, PaymentRetryMethod, PaymentStatusEnum, PayModeLevel1, PayRunDerivedStatus, PlanCategory, PlanIntervalType, SmsTransactionStatus, SubscriptionStatus, TransactionType, WhatsAppMessageTransactionLogStatus } from '@fitness-force/enum';
import { HiddenField, TimePeriodDropdown, Dropdown, MultiSelect, InputSwitch, Textbox, DatePicker,RelativeDate, REPORTSTOREINTERFACE } from '@fitness-force/models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})


export class ReportDataService {
  private  commonService = inject(CommonService);


  

  commonFields = [
    new HiddenField({
      value: '',
      key: 'from_date',
      label: '',
      required: false,
      order: 0,
      type: 'hidden',
    }),
    new HiddenField({
      value: '',
      key: 'to_date',
      label: '',
      required: false,
      order: 0,
      type: 'hidden',
    }),
  ];

  defaultOptions: Array<any> = [{ key: "All", value: 'null' }];
  defaultOptionsForClientServiceCategoryReport: Array<any> = [{ key: "Any", value: 'null' }];
  paymemt_status_values: Array<any> = [];
  paymemt_mode_values: Array<any> = [];
  timePeriod: any;


  constructor() {
    const excludedPaymentStatuses = [PaymentStatusEnum.Void, PaymentStatusEnum.Erroneous, PaymentStatusEnum.Refunded];
    Object.keys(PaymentStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
      const val = PaymentStatusEnum[key as keyof typeof PaymentStatusEnum];
      if (!excludedPaymentStatuses.includes(val)) {
        this.paymemt_status_values.push(val);
      }
    });

    Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
      this.paymemt_mode_values.push(PayModeLevel1[key as keyof typeof PayModeLevel1])
    });

    this.timePeriod = this.commonService.GetTimePeriods();

  }

  centers!: Observable<any> | any;
  tenantId!: Observable<any> | any;

  public tenantObs = new Subject<number>();


  getDefaultPayload(relativeDate: RelativeDate, zone: string, fields: { key: string, value: any }[], fromDate?: Date | string, toDate?: Date | string, pass_date_range:boolean = true) {
    const payload: any = {};
    if (relativeDate == RelativeDate.CustomDateRange) {
      payload.from_date = (fromDate as Date).toISOString();
      payload.to_date = (toDate as Date).toISOString();
    }
    else {
      payload.from_date = this.commonService.GetRelativeFromDate(new Date(), relativeDate, 0)?.from_date?.toISOString();
      payload.to_date = this.commonService.GetRelativeFromDate(new Date(), relativeDate, 0)?.to_date?.toISOString();
    }
    if(!pass_date_range) {
      if(Object.hasOwn(payload, 'from_date')) delete payload.from_date;
      if(Object.hasOwn(payload, 'to_date')) delete payload.to_date;
    }
    payload.time_zone = zone;
    payload.page_no = 1;
    payload.page_size = 9999999;
    if (fields && fields.length > 0) {
      fields.forEach((value: { key: string, value: any }) => {
        payload[value.key] = value.value;
      })
    }
    return payload;
  }

  getPayload(zone: string, fields: { key: string, value: any }[], pass_date_range:boolean = true) {
    const payload: any = {};
    payload.from_date = "";
    payload.to_date = "";
    payload.page_no = 1;
    payload.page_size = 9999999;
    payload.time_zone = zone;

    if(!pass_date_range) {
      if(Object.hasOwn(payload, 'from_date')) delete payload.from_date;
      if(Object.hasOwn(payload, 'to_date')) delete payload.to_date;
    }

    if (fields && fields.length > 0) {
      fields.forEach((value: { key: string, value: any }) => {
        payload[value.key] = value.value;
      })
    }
    return payload;
  }

  getCustomDateRange(date: Date, days: number) {
    return new Date(new Date(date.setDate(date.getDate() + days)).setHours(0,0,0,0));
  }

  private static readonly SESSION_LIABILITY_REPORT_KEY = 'SessionLiabilityAndUtilizationReport';
  private static readonly PAYMENT_RUN_REPORT_KEY = 'PaymentRunReport';

  private static readonly SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS = [
    'company_level_plan_name',
    'company_level_service_category_name'
  ] as const;

  private static readonly PAYMENT_RUN_COMPANY_LEVEL_MULTI_SELECT_KEYS = [
    'company_level_plan_name'
  ] as const;

  /**
   * When all options are selected for company-level multiselect filters, store null
   * so the backend treats it as an "all" selection (avoids large comma-separated payloads).
   */
  normalizeCompanyLevelMultiSelectPayload(
    reportKey: string,
    payload: Record<string, unknown>,
    mandatoryFields: Array<{ key: string; options?: Array<{ key?: string; value: unknown }> }> = [],
    selectedValuesByKey: Record<string, unknown[]> = {},
    applicationState?: { plans?: Array<{ value: unknown }>; companyLevelServiceCategories?: Array<{ value: unknown }> }
  ): void {
    if (reportKey !== ReportDataService.SESSION_LIABILITY_REPORT_KEY && reportKey !== ReportDataService.PAYMENT_RUN_REPORT_KEY) {
      return;
    }

    if (reportKey === ReportDataService.SESSION_LIABILITY_REPORT_KEY) {
    for (const fieldKey of ReportDataService.SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS) {
      if (!Object.prototype.hasOwnProperty.call(payload, fieldKey)) {
        continue;
      }

      const allOptionValues = this.getMultiSelectOptionValues(mandatoryFields, fieldKey, applicationState);
      const selectedValues = this.resolveMultiSelectSelectedValues(
        fieldKey,
        payload[fieldKey],
        selectedValuesByKey
      );

      if (this.shouldStoreCompanyLevelMultiSelectAsNull(selectedValues, allOptionValues)) {
        payload[fieldKey] = null;
      }
    }
  }
   if (reportKey === ReportDataService.PAYMENT_RUN_REPORT_KEY) {
    for (const fieldKey of ReportDataService.PAYMENT_RUN_COMPANY_LEVEL_MULTI_SELECT_KEYS) {
      if (!Object.prototype.hasOwnProperty.call(payload, fieldKey)) {
        continue;
      }

      const allOptionValues = this.getMultiSelectOptionValues(mandatoryFields, fieldKey, applicationState);
      const selectedValues = this.resolveMultiSelectSelectedValues(
        fieldKey,
        payload[fieldKey],
        selectedValuesByKey
      );

      if (this.shouldStoreCompanyLevelMultiSelectAsNull(selectedValues, allOptionValues)) {
        payload[fieldKey] = null;
      }
    }
  }
  
  }

  /**
   * Resolves multiselect form values to the payload value.
   * Returns null when all options are selected; otherwise a comma-separated string.
   */
  resolveCompanyLevelMultiSelectPayloadValue(
    reportKey: string,
    fieldKey: string,
    selectedValues: unknown[],
    mandatoryFields: Array<{ key: string; options?: Array<{ key?: string; value: unknown }> }> = [],
    applicationState?: { plans?: Array<{ value: unknown }>; companyLevelServiceCategories?: Array<{ value: unknown }> }
  ): string | null {
    if (reportKey !== ReportDataService.SESSION_LIABILITY_REPORT_KEY) {
      return selectedValues.join(',');
    }

    if (!ReportDataService.SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS.includes(fieldKey as typeof ReportDataService.SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS[number])) {
      return selectedValues.join(',');
    }

    const allOptionValues = this.getMultiSelectOptionValues(mandatoryFields, fieldKey, applicationState);
    if (this.shouldStoreCompanyLevelMultiSelectAsNull(selectedValues, allOptionValues)) {
      return null;
    }

    return selectedValues.join(',');
  }

  private shouldStoreCompanyLevelMultiSelectAsNull(
    selectedValues: unknown[],
    allOptionValues: unknown[]
  ): boolean {
    if (selectedValues.length === 0) {
      return false;
    }

    if (selectedValues.some((value) => value === 'null' || value === null)) {
      return true;
    }

    if (allOptionValues.length === 0) {
      return false;
    }

    const selectedSet = new Set(selectedValues.map((value) => String(value)));
    const optionSet = new Set(allOptionValues.map((value) => String(value)));

    return optionSet.size > 0 && [...optionSet].every((value) => selectedSet.has(value));
  }

  private resolveMultiSelectSelectedValues(
    fieldKey: string,
    rawValue: unknown,
    selectedValuesByKey: Record<string, unknown[]>
  ): unknown[] {
    if (selectedValuesByKey[fieldKey]?.length) {
      return selectedValuesByKey[fieldKey];
    }

    if (Array.isArray(rawValue)) {
      return rawValue;
    }

    if (rawValue === null || rawValue === '' || rawValue === 'null') {
      return [];
    }

    // Name-based company-level filters may contain commas; avoid splitting saved strings.
    if (ReportDataService.SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS.includes(fieldKey as typeof ReportDataService.SESSION_LIABILITY_COMPANY_LEVEL_MULTI_SELECT_KEYS[number])) {
      return typeof rawValue === 'string' ? [rawValue] : [];
    }

    if (typeof rawValue === 'string') {
      return rawValue.split(',').map((value) => value.trim()).filter((value) => value.length > 0);
    }

    return [];
  }

  private getMultiSelectOptionValues(
    mandatoryFields: Array<{ key: string; options?: Array<{ key?: string; value: unknown }> }>,
    fieldKey: string,
    applicationState?: { plans?: Array<{ value: unknown }>; companyLevelServiceCategories?: Array<{ value: unknown }> }
  ): unknown[] {
    const field = mandatoryFields.find((mandatoryField) => mandatoryField.key === fieldKey);
    const fieldOptions = field?.options
      ?.filter((option) => option.value !== 'null' && option.value !== null && option.key !== 'All')
      .map((option) => option.value) ?? [];

    if (fieldOptions.length > 0) {
      return fieldOptions;
    }

    if (fieldKey === 'company_level_plan_name') {
      return applicationState?.plans?.map((plan) => plan.value) ?? [];
    }

    if (fieldKey === 'company_level_service_category_name') {
      return applicationState?.companyLevelServiceCategories?.map((category) => category.value) ?? [];
    }

    return [];
  }

  /**
   *
   * @param tenantId
   * @param applicationState: application state is ref to application state(ngrx),
   * @returns
   */

  GetReportStoreData(tenantId: number, applicationState: any, languageCode:string="en") {
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const INITIAL_REPORT_STATE: REPORTSTOREINTERFACE[] = [
      {
        report_key: 'SubscriptionSignUpReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "plan_subscription_category", value: null },  { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "plan_id", value: null }, { key: "plan_subscription_category", value: null },{ key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: null,
            key: 'plan_subscription_category',
            label: 'Subscription Type',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientListReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "full_name", value: null }, { key: "home_club_id", value: this.tenantId }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "full_name", value: null }, { key: "home_club_id", value: this.tenantId }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'PaymentReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "str_payment_mode_level_1", value: null }, { key: "str_payment_status", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "str_payment_mode_level_1", value: this.paymemt_mode_values.join(',') }, { key: "str_payment_status", value: this.paymemt_status_values.join(',') }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: this.paymemt_mode_values,
            key: 'str_payment_mode_level_1',
            label: 'Payment Mode',
            required: true,
            order: 2,
            options: Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PayModeLevel1[key as keyof typeof PayModeLevel1],
              };
            }),
          }),
          new MultiSelect({
            value: this.paymemt_status_values,
            key: 'str_payment_status',
            label: 'Payment Status',
            required: true,
            order: 3,
            options: Object.keys(PaymentStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PaymentStatusEnum[key as keyof typeof PaymentStatusEnum],
              };
            }),
          })
          , new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionDetailReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "subscription_status", value: '' }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "subscription_status", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'subscription_status',
            label: 'Subscription Status',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key: key.replace(/([A-Z])/g, ' $1').trim(),
                value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'InProgressSubscriptionSignups',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastSevenDays, localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ChargesFees',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: '' },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Charge Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.charge_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'FailedSubscriptionSignups',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          // new Dropdown({
          //   value: 'null',
          //   key: 'clt_subs_status',
          //   label: 'Subscription Status',
          //   required: true,
          //   order: 1,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key: key.replace(/([A-Z])/g, ' $1').trim(),
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CompletedTasksByStaff',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "staff_id", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionExpired',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastSevenDays, localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionNotRenewing',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.CustomDateRange, localTimeZone, [{ key: "staff_id", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }], this.getCustomDateRange(new Date(), 1), this.getCustomDateRange( new Date(), 31))),
        default_relative_Date: RelativeDate[RelativeDate.CustomDateRange].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          // new Dropdown({
          //   value: 'null',
          //   key: 'clt_subs_status',
          //   label: 'Subscription Status',
          //   required: true,
          //   order: 1,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key: key.replace(/([A-Z])/g, ' $1').trim(),
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'WonBackClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastThirtyDays, localTimeZone, [{ key: "staff_id", value: null }])),
        default_relative_Date:RelativeDate[RelativeDate.LastThirtyDays].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ChurnClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),

        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastMonth, localTimeZone, [{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date:
          RelativeDate[RelativeDate.LastMonth].toString(),
          isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentByCoach',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "coach_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "coach_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Staff',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentByCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Appointment Type Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.appointmentTypes),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CancelledAppointmentByCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientCheckIns',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "event_type", value: null }, { key: "access_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "event_type", value: null }, { key: "access_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'event_type',
            label: 'CheckedIn Events',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(ClientCheckinEventType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientCheckinEventType[key as keyof typeof ClientCheckinEventType],
              };
            })),
          }),
          new Dropdown({
            value: '',
            key: 'access_status',
            label: 'Access status',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(ClientCheckedInStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientCheckedInStatus[key as keyof typeof ClientCheckedInStatus],
              };
            })),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'NewJoinerClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "include_rejoin", value: true }, { key: "include_drop_in", value: true }, { key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "include_rejoin", value: true }, { key: "include_drop_in", value: true }, { key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new InputSwitch({
            value: true,
            key: 'include_rejoin',
            label: 'Include Rejoiners',
            required: true,
            order: 3,
          }),
          new InputSwitch({
            value: true,
            key: 'include_drop_in',
            label: 'Include Drop-in',
            required: true,
            order: 4,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'InvoiceSummary',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "sales_rep", value: null }, { key: "str_inv_status", value: null }, { key: "created_by", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "sales_rep", value: null }, { key: "str_inv_status", value: null }, { key: "created_by", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { can_be_client_rep: any }) => s.can_be_client_rep).map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new MultiSelect({
            value: '',
            key: 'str_inv_status',
            label: 'Invoice Status',
            required: false,
            order: 3,
            options: Object.keys(InvoiceStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: InvoiceStatusEnum[key as keyof typeof InvoiceStatusEnum],
              };
            }),
          }),


          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            }))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClassAttendance',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_id", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_id", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_id',
            label: 'Class Type',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'class_booking_status',
            label: 'Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(ClientBookingStatusNumeric).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientBookingStatusNumeric[key as keyof typeof ClientBookingStatusNumeric],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClassLateCancellationAndNoShowReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'UnpaidClassBookingReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'class_booking_status',
            label: 'Booking Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(ClientBookingStatusNumeric).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientBookingStatusNumeric[key as keyof typeof ClientBookingStatusNumeric],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClassSummary',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key:"class_type_name_company_level",value:null},{ key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key:"class_type_name_company_level",value:null}, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options:this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'class_status',
            label: 'Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(ClassStatusNumeric).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassStatusNumeric[key as keyof typeof ClassStatusNumeric],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SalesByServiceCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: '' }, { key: "sales_rep", value: null },{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "plan_id", value: null }, { key: "sales_rep", value: null },{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() } ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }), new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'InvoiceDetail',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ARAgingSummaryByClient',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15}),
        default_payload: JSON.stringify({ "time_zone":localTimeZone,"page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 3,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'number_of_aging_intervals',
            label: 'No Of Intervals',
            order: 4,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'aging_interval_period_grouping_in_days',
            label: 'Interval period in Days',
            order: 5,
          }),
          new DatePicker({
            value: null,
            required: false,
            key: 'as_on_date',
            label: 'As On Date',
            order: 3,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ARAgingDetailReport',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "sales_rep": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15,"localized_value": false,"language_code": languageCode}),
        default_payload: JSON.stringify({ "time_zone":localTimeZone,"page_no": 1, page_size: 100, "sales_rep": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15,"localized_value": false,"language_code": languageCode}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 3,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'number_of_aging_intervals',
            label: 'No Of Intervals',
            order: 4,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'aging_interval_period_grouping_in_days',
            label: 'Interval period in Days',
            order: 5,
          }),
          new DatePicker({
            value: null,
            required: false,
            key: 'as_on_date',
            label: 'As On Date',
            order: 3,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'DiscountReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: '' }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "plan_id", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'TaskDone',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Task Category',
            required: true,
            order: 3,
            options: this.defaultOptions.concat(applicationState.task_category),
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: true,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientCreditBalance',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"str_tenant_ids":tenantId.toString() }),
        default_payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0 ,"str_tenant_ids":tenantId.toString()}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 2,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'MembershipRenewedReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisQuarter].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'MembershipExpiredReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CreditBalanceTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null },{ key: "credit_balance_transaction_type", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [{ key: "staff_id", value: null },{ key: "credit_balance_transaction_type", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisQuarter].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'credit_balance_transaction_type',
            label: 'Transaction Type',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(TransactionType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: TransactionType[key as keyof typeof TransactionType],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientsByServiceCategory',
        claims: [],

        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "client_channel": null,"as_on_date":new Date(),"client_source":null,"client_status":null ,"category_id":null,"localized_value": false,"language_code": languageCode}),
        default_payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "client_channel": null,"as_on_date":new Date(),"client_source":null,"client_status":null ,"category_id":null,"localized_value": false,"language_code": languageCode}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [         
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { can_be_client_rep: any }) => s.can_be_client_rep).map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
           new Dropdown({
            value: 'null',
            key: 'client_channel',
            label: 'Channel',
            required: false,
            order: 2,
            options:this.defaultOptions.concat(Object.keys(ClientChannelString).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientChannelString[key as keyof typeof ClientChannelString].toString(),
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'client_source',
            label: 'Source',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(CONSTANTS_DATA.CHANNEL_SOURCES.reduce((acc:any[], curr) => {
              curr.source.forEach(item => {
                acc.push({ key : item, value : item });  // Push key-value pair as an object
              });
              return acc;
            }, []))
          }),
          new Dropdown({
            value: 'null',
            key: 'client_status',
            label: 'Status',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(CONSTANTS_DATA.CLIENT_STATUS.filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key : key.key,
                value: key.value,
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 5,
            options: this.defaultOptionsForClientServiceCategoryReport.concat(applicationState.service_category),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SalesReturnDetailReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'EmailTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "email_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "email_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'email_transaction_status',
            label: 'Email Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(EmailTransactionLogStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: EmailTransactionLogStatus[key as keyof typeof EmailTransactionLogStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SMSTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "sms_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "sms_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'sms_transaction_status',
            label: 'Sms Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(SmsTransactionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: SmsTransactionStatus[key as keyof typeof SmsTransactionStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'WhatsAppTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "whatsapp_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "whatsapp_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'whatsapp_transaction_status',
            label: 'Whatsapp Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(WhatsAppMessageTransactionLogStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: WhatsAppMessageTransactionLogStatus[key as keyof typeof WhatsAppMessageTransactionLogStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'PaymentTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "payment_mode_level_1_single", value: null }, { key: "payment_log_derived_status", value: null },{ key: "auto_pay", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "payment_mode_level_1_single", value: null }, { key: "payment_log_derived_status", value: null }, { key: "auto_pay", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'payment_mode_level_1_single',
            label: 'Payment Mode',
            required: true,
            order: 2,
            options: Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PayModeLevel1[key as keyof typeof PayModeLevel1],
              };
            }),
          }),
          new Dropdown({
            value: 'null',
            key: 'payment_log_derived_status',
            label: 'Payment Derived Status',
            required: true,
            order: 3,
            options: Object.keys(PaymentDerivedStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PaymentDerivedStatus[key as keyof typeof PaymentDerivedStatus],
              };
            }),
          }),
          new Dropdown({
            value: 'null',
            key: 'auto_pay',
            label: 'Auto Pay',
            required: true,
            order: 3,
            options: Object.keys(YesNo).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: YesNo[key as keyof typeof YesNo],
              };
            }),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CountByMemberCategoryWise',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "service_category_name", value: '' },{key:"include_non_base_membership",value:false},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "service_category_name", value: '' },{key:"include_non_base_membership",value:false},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'service_category_name',
            label: 'Service Category Name',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.service_category),
          }),
          new InputSwitch({
            value: true,
            key: 'include_non_base_membership',
            label: 'Include Non Base Membership',
            required: false,
            order: 3,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientTrialReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "trial_type", value: 'ClassBased' },{key:"conversion",value: true},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "trial_type", value: 'ClassBased' },{key:"conversion",value: true},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'trial_type',
            label: 'Trial Type',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(Object.keys(TrialType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: TrialType[key as keyof typeof TrialType],
              };
            })),
          }),
          new InputSwitch({
            value: true,
            key: 'conversion',
            label: 'Conversion',
            required: false,
            order: 3,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'FreezeReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "freeze_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "freeze_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'freeze_status',
            label: 'Freeze Status',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(Object.keys(ClientSubscriptionFreezeStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientSubscriptionFreezeStatus[key as keyof typeof ClientSubscriptionFreezeStatus],
              };
            })),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'PaymentRunReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "company_level_plan_name", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "client_payment_token_status", value: null },{ key: "pay_run_derived_status", value: null },{ key: "retry_method", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "company_level_plan_name", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "client_payment_token_status", value: null },{ key: "pay_run_derived_status", value: null },{ key: "retry_method", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: [],
            key: 'company_level_plan_name',
            label: 'Plan Name',
            required: false,
            order: 2,
            options: applicationState.plans,
          }),
          new Dropdown({
            value: 'null',
            key: 'client_payment_token_status',
            label: 'Client Payment Token Status',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(Object.keys(ClientPaymentTokenStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientPaymentTokenStatus[key as keyof typeof ClientPaymentTokenStatus],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'pay_run_derived_status',
            label: 'Pay Run Derived Status',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(PayRunDerivedStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PayRunDerivedStatus[key as keyof typeof PayRunDerivedStatus],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'retry_method',
            label: 'Retry Method',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(PaymentRetryMethod).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PaymentRetryMethod[key as keyof typeof PaymentRetryMethod],
              };
            })),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'RefundReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "minor_currency", value: 0 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "minor_currency", value: 0 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Textbox({
            value: 0,
            key: 'minor_currency',
            label: 'Refund Amount',
            required: false,
            order: 2,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionCohort',
        claims: ['can_see_reports'],
        analytics_path_param: "SubscriptionCohort",
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'Subscription' },{ key: "interval_list ", value: null },{ key: "multi_tenant_franchise_filter", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'Subscription' },{ key: "interval_list ", value: null },{ key: "multi_tenant_franchise_filter", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: [],
            key: 'plan_list',
            label: 'Plan Name',
            required: false,
            order: 2,
            options: applicationState.plans,
          }),
          new MultiSelect({
            value: [],
            key: 'category_list',
            label: 'Category Name',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          new MultiSelect({
            value: [],
            key: 'subscription_status_list',
            label: 'Subscription Status Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
              };
            })),
          }),
          new MultiSelect({
            value: [],
            key: 'interval_list',
            label: 'Interval Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(PlanIntervalType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanIntervalType[key as keyof typeof PlanIntervalType],
              };
            })),
          }),
          new Textbox({
            value: 60,
            key: 'max_months',
            label: 'Max Months',
            required: false,
            order: 5,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientCohort',
        claims: ['can_see_reports_finance'],
        analytics_path_param: "ClientsCohort",
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'Clients' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'Clients' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: [],
            key: 'plan_list',
            label: 'Plan Name',
            required: false,
            order: 2,
            options: applicationState.plans,
          }),
          new MultiSelect({
            value: [],
            key: 'category_list',
            label: 'Category Name',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          new MultiSelect({
            value: [],
            key: 'subscription_status_list',
            label: 'Subscription Status Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
              };
            })),
          }),
          new MultiSelect({
            value: [],
            key: 'interval_list',
            label: 'Interval Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(PlanIntervalType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanIntervalType[key as keyof typeof PlanIntervalType],
              };
            })),
          }),
          new Textbox({
            value: 60,
            key: 'max_months',
            label: 'Max Months',
            required: false,
            order: 5,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'MRRCohort',
        claims: ['can_see_reports_finance'],
        analytics_path_param: "MRRCohort",
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'MRR' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'Clients' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: [],
            key: 'plan_list',
            label: 'Plan Name',
            required: false,
            order: 2,
            options: applicationState.plans,
          }),
          new MultiSelect({
            value: [],
            key: 'category_list',
            label: 'Category Name',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          // new MultiSelect({
          //   value: '',
          //   key: 'subscription_status_list',
          //   label: 'Subscription Status Name',
          //   required: false,
          //   order: 4,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key,
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // }),
          new MultiSelect({
            value: [],
            key: 'interval_list',
            label: 'Interval Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(PlanIntervalType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanIntervalType[key as keyof typeof PlanIntervalType],
              };
            })),
          }),
          new Textbox({
            value: 60,
            key: 'max_months',
            label: 'Max Months',
            required: false,
            order: 5,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ARRCohort',
        claims: ['can_see_reports_finance'],
        analytics_path_param: "ARRCohort",
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'ARR' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key: "subscription_status_list", value: null },{key: "metric", value: 'ARR' },{ key: "interval_list ", value: null },{ key: "interval_list", value: null },{ key: "plan_list", value: null },{ key: "category_list", value: null },{ key: "max_months", value: 60 },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: [],
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: [],
            key: 'plan_list',
            label: 'Plan Name',
            required: false,
            order: 2,
            options: applicationState.plans,
          }),
          new MultiSelect({
            value: [],
            key: 'category_list',
            label: 'Category Name',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          // new MultiSelect({
          //   value: [],
          //   key: 'subscription_status_list',
          //   label: 'Subscription Status Name',
          //   required: false,
          //   order: 4,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key,
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // }),
          new MultiSelect({
            value: [],
            key: 'interval_list',
            label: 'Interval Name',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(PlanIntervalType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanIntervalType[key as keyof typeof PlanIntervalType],
              };
            })),
          }),
          new Textbox({
            value: 60,
            key: 'max_months',
            label: 'Max Months',
            required: false,
            order: 5,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'RecognizedRevenueDetails',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "service_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [ {key: "service_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Textbox({
            value: '',
            key: 'minor_currency',
            label: 'Currency',
            required: false,
            order: 1,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'DeferredRevenueDetails',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "service_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [ {key: "service_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisQuarter].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Textbox({
            value: '',
            key: 'minor_currency',
            label: 'Currency',
            required: false,
            order: 1,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'StockInventoryReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key: "retail_brand_id", value: null },{key: "retail_product_status", value: null },{key: "retail_product_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [ {key: "retail_brand_id", value: null },{key: "retail_product_status", value: null },{key: "retail_product_category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_brand_id',
            label: 'Retail Brand',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.brands),
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_product_category_id',
            label: 'Product Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.productCategories),
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_product_status',
            label: 'Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(Status).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: Status[key as keyof typeof Status],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SessionLiabilityAndUtilizationReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "company_level_service_category_name", value: null },{key:"company_level_plan_name",value:null},{key:"session_type",value:null},{key:"session_owner_id",value:null},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }], false)),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "company_level_service_category_name", value: null },{key:"company_level_plan_name",value:null},{key:"session_type",value:null},{key:"session_owner_id",value:null},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }],'','',false)),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          // new TimePeriodDropdown({
          //   value: '',
          //   key: 'timePeriod',
          //   label: 'Time Period',
          //   required: true,
          //   order: 1,
          //   options: this.timePeriod,
          // }),
          new MultiSelect({
            value: [],
            key: 'company_level_service_category_name',
            label: 'Service Category Name',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.companyLevelServiceCategories),
          }),
          new MultiSelect({
            value: [],
            key: 'company_level_plan_name',
            label: 'Plan Name',
            required: false,
            order: 3,
            options: applicationState.plans,
          }),
          new Dropdown({
            value: 'null',
            key: 'session_type',
            label: 'Session Type',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(ServiceCategoryBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ServiceCategoryBehaviour[key as keyof typeof ServiceCategoryBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'session_owner_id',
            label: 'Session Owner',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'LostOpportunities',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "opportunity_stage", value: null },{ key: "opportunity_convertibility", value: null },{ key: "opportunity_assigned_to", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "opportunity_stage", value: null },{ key: "opportunity_convertibility", value: null },{ key: "opportunity_assigned_to", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'opportunity_assigned_to',
            label: 'Opportunity Assigned To',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'opportunity_stage',
            label: 'Opportunity Stage',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(applicationState.opportunityStages),
          }),
          new Dropdown({
            value: 'null',
            key: 'opportunity_convertibility',
            label: 'Opportunity Convertibility',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(OpportunitiesType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: OpportunitiesType[key as keyof typeof OpportunitiesType],
              };
            })),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'classRatingSummaryReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'classRatingByCoachSummaryReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { role: string; can_take_class: any }) => s.can_take_class || s.role == 'Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            }))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentRatingSummaryReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "appointment_type_name_company_level", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "appointment_type_name_company_level", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'appointment_type_name_company_level',
            label: 'Appointment Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.appointmentTypes)
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentRatingByCoachSummaryReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "appointment_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "appointment_type_name_company_level", value: null }, { key: "coach_id", value: null }, { key: "localized_value", value: false }, { key: "language_code", value: languageCode }, { key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'appointment_type_name_company_level',
            label: 'Appointment Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.appointmentTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { role: string; can_take_class: any }) => s.can_take_class || s.role == 'Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            }))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'GuestPassUtilizationReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'GuestPassUtilizationAndLiabilityReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'RetailSalesByProductReport',
        claims: ['can_see_reports_retail'],
        payload: JSON.stringify(this.getPayload(localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_product_category_id',
            label: 'Category',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.productCategories),
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_product_name',
            label: 'Product Name',
            order: 3,
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_sku_name',
            label: 'SKU Name',
            order: 4,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'RetailSalesByStaffReport',
        claims: ['can_see_reports_retail'],
        payload: JSON.stringify(this.getPayload(localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: 'retail_staff_id', value: null },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: 'retail_staff_id', value: null },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_staff_id',
            label: 'Staff',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => ({
              key: staff.name,
              value: staff.id,
            })) || []),
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_product_category_id',
            label: 'Category',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState.productCategories),
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_product_name',
            label: 'Product Name',
            order: 4,
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_sku_name',
            label: 'SKU Name',
            order: 5,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'RetailStockMovementReport',
        claims: ['can_see_reports_retail'],
        payload: JSON.stringify(this.getPayload(localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [
          { key: 'retail_product_category_id', value: null },
          { key: 'retail_product_name', value: '' },
          { key: 'retail_sku_name', value: '' },
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'retail_product_category_id',
            label: 'Category',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.productCategories),
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_product_name',
            label: 'Product Name',
            order: 3,
          }),
          new Textbox({
            value: '',
            required: false,
            key: 'retail_sku_name',
            label: 'SKU Name',
            order: 4,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientReferralReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [
          { key: "localized_value", value: false },
          { key: "language_code", value: languageCode },
          { key: "str_tenant_ids", value: tenantId.toString() }
        ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel: false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      }

      
    ];
    return INITIAL_REPORT_STATE;
  }
}
